import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { closeModal } from '@/store/slices/modalSlice';
import LoginModal from './LoginModal';

const ModalManager: React.FC = () => {
  const dispatch = useDispatch();
  const { activeModal } = useSelector((state: RootState) => state.modal);

  const handleClose = () => dispatch(closeModal());

  return (
    <>
      <LoginModal isOpen={activeModal === 'login'} onClose={handleClose} />
    </>
  );
};

export default ModalManager;
